export const urlToFileName = (url) => {
  let filename = "";
  if (url) {
    filename = url.toString().split("/").pop();
  }
  return filename;
};
